import { ExternalLink, PlayCircle } from "lucide-react";

function parseEmbed(url) {
  try {
    const u = new URL(url);
    const host = u.hostname.replace("www.", "");
    if (host.includes("youtube.com")) {
      const id = u.searchParams.get("v");
      if (id) return { type: "iframe", src: `https://www.youtube.com/embed/${id}` };
      if (u.pathname.startsWith("/embed/")) return { type: "iframe", src: url };
    }
    if (host === "youtu.be") return { type: "iframe", src: `https://www.youtube.com/embed${u.pathname}` };
    if (host.includes("vimeo.com")) {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id) return { type: "iframe", src: `https://player.vimeo.com/video/${id}` };
    }
  } catch { /* ignore */ }
  return { type: "link", src: url };
}

export const VideoEmbed = ({ url, title }) => {
  const { type, src } = parseEmbed(url);
  if (type === "iframe")
    return (
      <div className="aspect-video w-full overflow-hidden rounded-t-xl bg-black">
        <iframe
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="h-full w-full"
        />
      </div>
    );
  return (
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex aspect-video w-full flex-col items-center justify-center gap-2 rounded-t-xl bg-black text-cream"
    >
      <PlayCircle className="h-10 w-10 text-gold transition-transform group-hover:scale-110" strokeWidth={1.2} />
      <span className="flex items-center gap-1 text-sm text-muted-foreground">Watch <ExternalLink className="h-3.5 w-3.5" /></span>
    </a>
  );
};
